import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  content: {
    width: "100%",
  },
  titles_container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "24px",
  },
  message: {
    marginTop: 24,
    [theme.breakpoints.down("desktop")]: {
      marginTop: 28,
    },
  },
  textSmallWidth: {
    width: "350px",
  },
}));

export default useStyles;
